import PartnerIntegrationShow from './wallet-integration.show';
import PartnerIntegrationEdit from './wallet-integration.edit';

export default {
  show: PartnerIntegrationShow,
  edit: PartnerIntegrationEdit,
};
